// extracted by mini-css-extract-plugin
export var sbShowMain = "videoInline-module--sb-show-main--3Km9w";
export var desktopAndTablet = "videoInline-module--desktopAndTablet--2MB68";
export var uploadedVideo = "videoInline-module--uploadedVideo--2V4EL";
export var mobileOnly = "videoInline-module--mobileOnly--2Kt7e";